import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../common/constants";
import { DocSignatureStatus } from "../enums";

const getColor = (status: DocSignatureStatus) => {
  switch (status) {
    case DocSignatureStatus.SIGNED:
      return PresetColors.GREEN;
    default:
      return PresetColors.BLUE;
  }
};

type Props = {
  status: DocSignatureStatus;
};

export const DocSignatureStatusTag = ({ status }: Props) => {
  const { t } = useTranslation();

  return <Tag color={getColor(status)}>{t("documentSign.enums.docSignatureStatus." + status)}</Tag>;
};
